import script from "./color-fact-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-fact-menu.vue?vue&type=script&setup=true&lang=ts"

import "./color-fact-menu.vue?vue&type=style&index=0&id=5d56dd04&lang=scss"

const __exports__ = script;

export default __exports__